module.exports = __webpack_public_path__ + "img/redis.5472a2bf.png";